// @ts-nocheck

// @index('./*.vue', (f, _) => `import { default as InstantDelivery${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as InstantDeliveryActions } from './actions.vue'
// @endindex

export const InstantDeliveryComponents = {
  // @index('./*.vue', (f, _) => `InstantDelivery${_.pascal(f.name)},`)
  InstantDeliveryActions,
  // @endindex
}
